import { render, staticRenderFns } from "./PricingEditDialog.vue?vue&type=template&id=7143b4c8"
import script from "./PricingEditDialog.vue?vue&type=script&lang=js"
export * from "./PricingEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports